import { render, staticRenderFns } from "./ExportPermits.vue?vue&type=template&id=1e3918fc"
import script from "./ExportPermits.vue?vue&type=script&lang=js"
export * from "./ExportPermits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports